<main class="main-content debugx">
    <section class="section section-home-header">
        <div class="st-inner">
            <span class="before"></span>
            <div class="container">
                <div class="content">
                    <div class="st-header">
                        <h2 class="h2 f1 mb-0">Welkom op de</h2>
                        <h3 class="h1">scholenwijzer Den Haag</h3>
                    </div>

                    <div class="category-nav">
                        <ul class="category-list primary">
                            <li>
                                <a [routerLink]="['/', 'categorie', 'ko']" class="cat-button ko" title="Ga naar kinderopvang"
                                    >Kinderopvang <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'categorie', 'po']" class="cat-button bo" title="Ga naar basisschool"
                                    >Basisschool <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'categorie', 'vo']" class="cat-button vo" title="Ga naar middelbare school"
                                    >Middelbare school <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'locatie', 'vavo', '2958']" class="cat-button vavo" title="Ga naar VAVO"
                                    >VAVO <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'categorie', 'mbo']" class="cat-button mbo" title="Ga naar mbo"
                                    >MBO <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'categorie', 'hbo-wo']" class="cat-button hbo" title="Ga naar HBO &amp; WO"
                                    >HBO &amp; Universiteit <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                        </ul>

                        <ul class="category-list secondary">
                            <li>
                                <a [routerLink]="['/', 'categorie', 'so']" class="cat-button so" title="Ga naar speciaal onderwijs"
                                    >Speciaal onderwijs <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li>
                                <a [routerLink]="['/', 'categorie', 'int']" class="cat-button io" title="Ga naar internationaal onderwijs"
                                    >Internationaal onderwijs <span class="arrow"><i class="icon-right-small"></i></span
                                ></a>
                            </li>
                            <li class="newcomer-button-wrapper" routerLink="nieuw-in-nederland">
                                <a class="newcomer-button-text">nieuw in nederland</a>
                                <div class="flex-wrapper">
                                    <a routerLink="nieuw-in-nederland/po">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/POOLS.svg" alt="" />
                                        </span>
                                    </a>
                                    <a routerLink="nieuw-in-nederland/uk">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/OEKRAIENS.svg" alt="" />
                                        </span>
                                    </a>
                                    <a routerLink="nieuw-in-nederland/en">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/ENGELS.svg" alt="" />
                                        </span>
                                    </a>
                                    <a routerLink="nieuw-in-nederland/nl">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/NEDERLANDS.svg" alt="" />
                                        </span>
                                    </a>
                                </div>
                                <div class="flex-wrapper bottom-row">
                                    <a routerLink="nieuw-in-nederland/bu">
                                        <span class="circle">
                                            <img src="../../assets/img/homepage/flag-buttons/BULGAARS.svg" alt="" />
                                        </span>
                                    </a>
                                    <a routerLink="nieuw-in-nederland/tu">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/TURKS.svg" alt="" />
                                        </span>
                                    </a>
                                    <a routerLink="nieuw-in-nederland/ar">
                                        <span class="circle">
                                            <img src="assets/img/homepage/flag-buttons/ARABISCH.svg" alt="" />
                                        </span>
                                    </a>
                                    <div class="arrow-wrapper">
                                        <img src="assets/img/homepage/flag-buttons/arrow-right.svg" alt="" class="arrow-img" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-home-article-a">
        <div class="st-inner py-0">
            <div class="container">
                <div class="row">
                    <div [ngClass]="{
                        'js-mh': contentLoaded()
                    }" class="col-md-5 col-left" style="height: 650px">
                        <figure class="st-image bgimg" style="background-image: url('/assets/img/homepage/scholenwijzer01.jpg');">
                            <span class="overlay"></span>
                            <img src="/assets/img/homepage/scholenwijzer01.jpg" alt="Beschrijving van de foto" />
                        </figure>
                    </div>

                    <div class="col-md-7 col-right js-mh">
                        <div class="inner">
                            <div class="st-header">
                                <h1 class="h1">{{ pageContent.block_1_title ?? '' }}</h1>
                            </div>
                            <div class="article-output">
                                <div [innerHTML]="pageContent.block_1_body ?? ''"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-home-article-b">
        <div class="st-inner">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-lg-4 col-left">
                        <figure
                            class="st-image bgimg has-before"
                            style="background-image: url('/assets/img/homepage/Mariette-van-Leeuwen_0096-1300x867.webp');">
                            <img alt="Mariette van Leeuwen" src="/assets/img/homepage/Mariette-van-Leeuwen_0096-1300x867.webp" />
                        </figure>
                    </div>

                    <div class="col-md-6 col-lg-8 col-right">
                        <div class="inner indent">
                            <div class="st-header">
                                <h2 class="h2 mb-0">{{ pageContent.block_2_title ?? '' }}</h2>
                            </div>
                            <div class="article-output">
                                <div [innerHTML]="pageContent.block_2_body ?? ''"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-home-article-c">
        <div class="st-inner pb-12">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-left">
                        <div class="inner indent">
                            <div class="st-header a-right">
                                <h2 class="h2 mb-0" [innerHTML]="pageContent.block_3_title ?? ''"></h2>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-right">
                        <div class="inner">
                            <div class="article-output">
                                <div [innerHTML]="pageContent.block_3_body ?? ''"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-home-article-a">
        <div class="st-inner py-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-left js-mh">
                        <figure class="st-image bgimg" style="background-image: url('/assets/img/homepage/scholenwijzer02.jpg');">
                            <span class="overlay"></span>
                            <img src="/assets/img/homepage/scholenwijzer02.jpg" alt="Beschrijving van de foto" />
                        </figure>
                    </div>

                    <div class="col-md-7 col-right js-mh">
                        <div class="inner">
                            <div class="st-header">
                                <h2 class="h2">{{ pageContent.block_4_title ?? '' }}</h2>
                            </div>
                            <div class="article-output">
                                <div [innerHTML]="pageContent.block_4_body ?? ''"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
